import { Delete, Edit } from '@mui/icons-material'
import { Box, Button, Dialog, DialogContent, FormControlLabel, Grid, IconButton, Switch, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ApiCreateFeedbackQuestions, ApideleteFeedbackQuestion, ApiGetFeedbackQuestions, ApiUpdateFeedbackQuestions } from '../../apiService/Core/Apicall'
import { toast } from 'react-toastify'
import { number } from 'yup'
import { useSelector } from 'react-redux'
import { RootState } from '../../global/config/Reducer'
import storage from '../../utils/storage'

function FeedbackQuestions() {
    const [createquestions, setcreatequestions] = useState<any[]>([{
        questions: '',
        clientEntityId: parseInt(storage.getItem('clientEntityId') || '0'),
        isActive: true
    }])
    const [getquestions, setgetquestions] = useState<any>([])
    const [editedquestion, seteditquestion] = useState<string>('')
    const [editedquestiondata, seteditquestiondata] = useState<any>()
    const [isedit, setisedit] = useState<any>()
    const [confirmpopup, setconfirmpopup] = useState<boolean>(false)
    const [iscreatenew, setiscreatenew] = useState<boolean>(false)
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)


    const handlequestionvalue = (e: any, index: number) => {
        const { value } = e.target
        setcreatequestions((prev: any) =>
            prev.map((question: any, i: number) =>
                i === index ? { ...question, questions: value } : question
            ))
    }

    const addmoreQuestion = () => {
        setcreatequestions((prev: any) =>
            [...prev,
            {
                questions: '',
                clientEntityId: parseInt(storage.getItem('clientEntityId') || '0'),
                isActive: true
            }
            ])
    }

    const handlecreateQuestions = async () => {
        try {
            const data = {
                "questions": createquestions
            }
            const isValid = createquestions.length > 0 &&
                createquestions.every(item => item.questions.trim().length > 0);

            if (isValid) {
                const res = await ApiCreateFeedbackQuestions(data)
                if (res.status) {
                    // toast.success("Feedbak Questions created Successfully")
                    setcreatequestions([{
                        questions: '',
                        clientEntityId: parseInt(storage.getItem('clientEntityId') || '0'),
                        isActive: true
                    }])
                    setgetquestions(res.data)
                }
                HandlegetFeedbackQuestisons()
            }
            else {
                toast.error("questions are required")
            }

        } catch (error: any) {
            const message =
                error?.response?.data?.message || error?.message || String(error);
            toast.error(message);
        }

    }

    const removequestion = (index: number) => {
        setcreatequestions((prev) => prev.filter((_, i) => i !== index));
    };
    const handleupdatequestion = async () => {
        setconfirmpopup(false)
        try {
            const data =
            {
                "reportFeedbackQuestionId": editedquestiondata?.reportFeedbackQuestionId,
                "questions": editedquestion,
                "clientEntityId": parseInt(storage.getItem('clientEntityId') || '0'),
                "isActive": true,
                "iscreatedNew": iscreatenew
            }
            const res = await ApiUpdateFeedbackQuestions(data)
            if (res.status) {
                // toast.success("Question updated Successfully")
                setisedit(null)
                seteditquestiondata(null)
                setiscreatenew(false)

            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message || error?.message || String(error);
            toast.error(message);
        }

        HandlegetFeedbackQuestisons()
    };

    const HandlegetFeedbackQuestisons = async () => {
        try {
            const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
            const res = await ApiGetFeedbackQuestions(data)
            if (res.status) {
                setgetquestions(res.data)
                // toast.success("Feedbak Questions Get Successfully")
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message || error?.message || String(error);
            toast.error(message);
        }
    }

    useEffect(() => {
        clientEntity && HandlegetFeedbackQuestisons()
    }, [clientEntity, isGroupScore])

    const handleDelete = async (id: any) => {
        try {
            const res = await ApideleteFeedbackQuestion(`?reportFeedbackQuestionId=${id}`)
            toast.success(res?.message)
            HandlegetFeedbackQuestisons();
        } catch (error: any) {
            console.error("Error Deleting question.", error);
            const message =
                error?.response?.data?.message || error?.message || String(error);
            toast.error(message);
        }
    }

    return (
        <Box className='w-100' height={'calc(100vh - 100px)'}>
            {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                <Box className='w-100 d-flex justify-content-end mb-2'>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isGroupScore}
                                onChange={(e) => setisGroupScore(e.target.checked)}
                            />
                        }
                        label={"Whole Group"}
                    />
                </Box>)}
            <Grid container className='h-100'>
                <Grid size={8} className='h-100 p-2' overflow={'auto'} borderRight='1px solid #ccc'>
                    {getquestions?.length > 0 ?
                        (getquestions?.map((item: any, index: any) => (
                            <Box key={index} className='p-2 border border-10 mb-2'>
                                <Box className='d-flex align-items-start justify-content-between'>
                                    <Box className='d-flex align-items-start gap-2'>
                                        <Typography className='fw-bold' variant='body1'>Q{index + 1}.</Typography>
                                        <Typography variant='body1'>{item?.questions}</Typography>
                                    </Box>
                                    <Box className="d-flex">
                                        <IconButton onClick={() => { setisedit(index); seteditquestion(item?.questions) }} className='p-0'><Edit /></IconButton>
                                        <IconButton onClick={() => { 
                                            const isConfirmed = window.confirm("Are You sure You Want to delete question?")
                                            if (isConfirmed) {
                                                handleDelete(item?.reportFeedbackQuestionId)
                                            }
                                        }}
                                        >
                                            <Delete sx={{ color: 'red' }} />
                                        </IconButton>
                                    </Box>
                                </Box>
                                {isedit === index && (<Box className='mt-3'>
                                    <TextField value={editedquestion} fullWidth minRows={3} multiline onChange={(e) => { seteditquestion(e.target.value) }} />
                                    <Button className='btn-main px-3 mt-2' onClick={() => { seteditquestiondata(item); setconfirmpopup(true) }}>Update</Button>
                                </Box>
                                )}
                            </Box>
                        ))) : <Box className='h-100 w-100 d-flex align-items-center justify-content-between'><Typography className='text-center w-100' variant='h6'>no questions found</Typography></Box>}
                </Grid>
                <Grid size={4} className='h-100 p-2' overflow={'auto'} >
                    <Box className='d-flex justify-content-between'>
                        <Typography variant='h6' className='fw-bold'>Create Question</Typography>
                        <Button className='btn-main px-5' onClick={handlecreateQuestions}>Create</Button>
                    </Box>
                    <hr className='my-1 mx-1' />
                    <Box className='mt-3'>
                        {createquestions?.map((item: any, index: number) => (
                            <Box sx={{ border: '1px solid #ccc', borderRadius: '10px' }} className='d-flex align-items-start mb-2 p-1 bg-light justify-content-between'>
                                <TextField className='bg-light' sx={{ "& fieldset": { border: '1px solid transparent !important' } }} placeholder='Write your question here...' value={item?.questions} onChange={(e) => { handlequestionvalue(e, index) }} multiline minRows={3} fullWidth />
                                <IconButton onClick={() => { removequestion(index) }}><Delete sx={{ color: 'red' }} /></IconButton>
                            </Box>
                        ))}
                        <Box className='d-flex justify-content-end mt-3'>
                            <Button className='btn-main px-3' onClick={() => { addmoreQuestion() }}>+ Add more</Button>
                        </Box>
                    </Box>
                </Grid>

            </Grid>
            <Dialog open={confirmpopup}>
                <DialogContent>
                    <Box className='p-2'>
                        <Typography className="mb-3" variant="h5"> Do you want to create new question ? <br className="mb-0 pb-0" /> <span className="mb-0 pb-0" style={{ fontSize: '16px' }}>Yes will create new question </span> <br className="mt-0 pt-0" /> <span className="mt-0 pt-0" style={{ fontSize: '16px' }}> No will update existing question</span></Typography>
                        <Box className='d-flex align-items-center gap-3 justify-content-center'>
                            <Button className='btn-main py-1 px-4' onClick={() => { setiscreatenew(true); handleupdatequestion(); }}>Yes</Button>
                            <Button className='btn-main py-1 px-4' onClick={() => { handleupdatequestion() }}>No</Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default FeedbackQuestions
